import { request } from './http'

export type RuleLabels = Record<string, Record<string, string>>

export interface RuleLabelsResponse {
  rules: RuleLabels
}

export function getRuleLabel(labels: RuleLabels | undefined, ruleId: string, locale: string): string {
  return labels?.[ruleId]?.[locale] ?? ruleId
}

export const ruleLabelsApi = {
  list: (): Promise<RuleLabelsResponse> => request<RuleLabelsResponse>('/v1/memory/rules'),
}
